import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { Constants } from '@models/constants';
import { PolicyDetailsService } from './../../../../_services/my-insurance/policy-details.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-imp-notice',
  templateUrl: './imp-notice.component.html',
  providers: [DatePipe],
})
export class ImpNoticeComponent implements OnInit {
  @Input() theme = 'red';
  @Input() impText: string;
  @Input() impText2: string;
  @Input() policy: any;
  @Input() linkText?: string;
  @Input() linkUrl?: string;
  @Input() informationText?: string = 'INFORMATION';
  safeText: SafeHtml;
  unenrollImpTextSafeText: SafeHtml;
  unenrollImpText: string;
  billedNoticeForUnenroll = false;
  impTextInNewLine: string;
  impTextIsScheduled: string;
  showTwoDaysOrLess: boolean;
  showMoreThanTwoDays: boolean;
  isAcmic: boolean;
  hideAlert = false;
  constructor(
    private datePipe: DatePipe,
    private policyDetailService: PolicyDetailsService,
    private acmicService: AcmicService,
    private sanitizer: DomSanitizer
  ) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  getDateCount(billedWithdrawalDate) {
    return this.policyDetailService.getDayDifference(billedWithdrawalDate);
  }
  setImportantText(policy) {
    if (policy && policy.scheduleBills) {
      policy.scheduleBills.filter((scheduledBill) => {
        if (scheduledBill.invoiceState === 'Billed') {
          this.billedNoticeForUnenroll = true;
          const billedWithdrawalDate = scheduledBill.dateDue;
          const withdrawalDateCount = this.getDateCount(billedWithdrawalDate);
          const displayedDate = this.datePipe?.transform(
              billedWithdrawalDate,
              Constants.DATE_MM_DD_YYYY
            );
          if (withdrawalDateCount > 2) {
            this.showMoreThanTwoDays = true;
            this.unenrollImpText = `Your next automatic payment is still scheduled for <b>${displayedDate}</b>. 
                                      Manual payments will begin after that.`;
          } else if (withdrawalDateCount <= 2) {
            this.showTwoDaysOrLess = true;
            this.unenrollImpText = `Your next automatic payment is scheduled on <b>${displayedDate}</b> 
                                      and <b>cannot be stopped or changed</b>. Manual payments will begin after that.`; 
          }
        }
      });
    }
  }
  ngOnInit(): void {
    if (this.policy) {
      this.setImportantText(this.policy);
    }
    if(this.impText){
      this.safeText = this.sanitizer.bypassSecurityTrustHtml(this.impText);
    }
    if(this.unenrollImpText){
      this.unenrollImpTextSafeText = this.sanitizer.bypassSecurityTrustHtml(this.unenrollImpText);
    }
  }

  onClose(){
    this.hideAlert = true;
  }
}
